<template>
  <div class="group relative flex flex-col lg:w-[auto]">
    <p class="text-sm font-medium text-grays-600">מיקום</p>
    <tooltip-small
      :class="[
        isTooltipVisible ? 'group-hover:opacity-100 group-hover:z-10' : '',
      ]"
      :positionBottom="true"
      :tooltipText="`${(street, address)}`"
      class="tooltip absolute left-[0] bottom-[68px] opacity-0 -z-10"
    />
    <template v-if="sale.sale && sale.sale.special_address">
      <span class="truncate truncate-2-rows">
        {{ sale.sale.special_address }}
      </span>
      <div
        class="bg-error text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
      >
        <span class="material-symbols-rounded text-xs">error</span>
        שינוי בכתובת
      </div>
    </template>
    <p
      v-else
      ref="textElement"
      class="text-base font-regular text-grays-900 truncate truncate-2-rows"
    >
      {{ street }}, {{ city }}. {{ address }}
    </p>
  </div>
</template>

<script>
import TooltipSmall from "@/components/Global/TooltipSmall.vue";

export default {
  name: "location-section",
  components: { TooltipSmall },
  props: {
    street: {
      type: String,
      required: true,
    },
    address: {
      type: String,
      required: true,
    },
    sale: {
      type: Object,
      required: false,
    },
    city: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isTooltipVisible: false,
    };
  },
  methods: {
    updateTooltipVisibility() {
      this.$nextTick(() => {
        const textElement = this.$refs.textElement;
        if (textElement) {
          const lineHeight = parseInt(getComputedStyle(textElement).lineHeight);
          const maxLines = 2;
          const isTextOverflowing =
            textElement.scrollHeight > lineHeight * maxLines;
          this.isTooltipVisible = isTextOverflowing;
        }
      });
    },
  },
  mounted() {
    this.updateTooltipVisibility();
  },
};
</script>

<style>
</style>